import React from "react"

import { useStaticQuery, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import Image from "gatsby-plugin-sanity-image"
import PropTypes from "prop-types"
import LazyHydrate from "react-lazy-hydration"

import * as styles from "./podcast.module.scss"
import { dateString } from "../../../helpers/portable-text-mapping"
import CopyContainer from "../../atoms/copy-container"
import Grid from "../../atoms/grid"
import Heading from "../../atoms/heading"
import Iframe from "../../atoms/iframe"
import StickyIntro from "../../atoms/sticky-intro"
import Tag from "../../atoms/tag"
import ButtonGroup from "../button-group"
import Social from "../social"

const Podcast = ({ podcast, color, feed }) => {
  const { site, allSanityDictionary } = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          siteUrl
        }
      }
      allSanityDictionary {
        nodes {
          key {
            current
          }
          value
        }
      }
    }
  `)

  return (
    <Grid col={2} className={!feed ? styles.container : ""}>
      <StickyIntro>
        <div className={styles.title}>
          <Tag color={color}>
            {
              allSanityDictionary.nodes.find(
                (item) => item.key.current === "podcast_title"
              )?.value
            }
          </Tag>
          {podcast.episode_number > 0 ? (
            <Tag
              color="white"
              url={`/podcast/${podcast.slug.current}`}
            >{`Ep #${podcast.episode_number}`}</Tag>
          ) : (
            ""
          )}
        </div>
        <Heading level={feed ? 2 : 1}>{podcast.title}</Heading>
        <Heading level="6" semantic={false}>
          {dateString(podcast.date)}
        </Heading>
        <Social
          shareLink={`${site.siteMetadata.siteUrl}/podcast/${podcast.slug.current}`}
          shareTitle={podcast.title}
          story
        />
        <ButtonGroup
          variant="secondary"
          external
          ctas={podcast.urls.map((cta) => ({
            url: cta.url,
            text: allSanityDictionary.nodes.find(
              (item) => item.key.current === `listen_${cta.platform}`
            )?.value,
          }))}
        />
        <LazyHydrate whenVisible>
          <div>
            <Iframe
              url={`${podcast.urls
                .find((url) => url.platform === "apple_music")
                .url?.replace(
                  "https://podcasts",
                  "https://embed.podcasts"
                )}&amp;itsct=podcast_box_player&amp;itscg=30200&amp;ls=1&amp;theme=light`}
              title={podcast.title}
            />
          </div>
        </LazyHydrate>
      </StickyIntro>
      <div className={`${styles.content} ${feed ? styles.content__feed : ""}`}>
        {podcast.image?.asset ? (
          <Image
            className={styles.image}
            {...podcast.image}
            width={600}
            alt={podcast.title}
          />
        ) : (
          <StaticImage
            className={styles.image}
            src="../../../images/scenes/star.jpg"
            alt=""
          />
        )}
        <CopyContainer content={podcast._rawSummary} />
      </div>
    </Grid>
  )
}

export default Podcast

Podcast.propTypes = {
  podcast: PropTypes.object.isRequired,
  color: PropTypes.string,
  feed: PropTypes.bool,
}

Podcast.defaultProps = {
  color: "bloodorange",
  feed: false,
}
